import { forwardRef } from 'react';
import TranslationText from '@Components/Utilities/TranslationText';

const SelectField = forwardRef((props, ref) => {
    return (
        <div className={props.class}>
            <label htmlFor={props.id} className={props.hideLabel ? 'visually-hidden' : props.labelClass || 'bold'}> {props.label} {props.required && !props.showRequired && <span className={props.requiredSpanClass || 'required red'} />}</label>
            <select autofocus aria-invalid={props.validationErrors ? true : false} aria-required={props.required} id={props.id} ref={ref} className={props.selectClass} onChange={props.onFieldChanged} disabled={props.disabled} onBlur={props.onFieldBlur} name={props.name} value={props.value}>
                {props.options && props.options.map((item) =>
                    <option key={item.Value + ' ' + item.Text} value={item.Value} disabled={item.Disabled}>{item.Text}</option>)}
            </select>{props.required && props.showRequired && <span className={props.requiredSpanClass || 'required red next-line'}><TranslationText tKey='sandhills.required' /></span>}
            <span className='error'>{props.validationErrors}</span>
        </div>
    );
});

export default SelectField;